import { createApi } from "@reduxjs/toolkit/query/react";
import { createCustomFetchBaseQuery } from "../baseQuery";

export const clientApi = createApi({
    reducerPath: "client",
    baseQuery: createCustomFetchBaseQuery(),
    endpoints: (builder) => ({
        getClients: builder.query({
            query: ({ page, limit, keyword,status }) => {
                let url = '/clients'
                if (page) {
                    url = `/clients?page=${page}`
                }
                if (limit) {
                    url += `&limit=${limit}`;
                }
                if (keyword) {
                    url += `&keyword=${keyword}`;
                }
                if (status) {
                    url += `&status=${status}`;
                }
                return {
                    url,
                    method: "GET",
                }
            },
            transformResponse: (response) => ({
                data: response.data || {},
                meta: response.meta,
            }),
        }),
        createClient: builder.mutation({
            query: (data) => ({
                url: `/clients`,
                method: "POST",
                body: data,
            }),
        }),
        updateClientDetails: builder.mutation({
            query: ({id,data}) => ({
                url: `/clients/${id}`,
                method: "PUT",
                body: data,
            }),
        }),
        deleteClient: builder.mutation({
            query: (id) => ({
                url: `/clients/${id}`,
                method: "DELETE",
            }),
        }),
    }),
});

export const {
    useGetClientsQuery,
    useUpdateClientDetailsMutation,
    useCreateClientMutation,
    useDeleteClientMutation,
} = clientApi;